"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _SecondaryNav = require("./SecondaryNav.style");

var SecondaryNav = function SecondaryNav(_ref) {
  var links = _ref.links,
      active = _ref.active,
      secondaryNavCtas = _ref.secondaryNavCtas,
      rest = _objectWithoutProperties(_ref, ["links", "active", "secondaryNavCtas"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      globalNav = _ref2.globalNav;

  return /*#__PURE__*/_react.default.createElement(_SecondaryNav.Wrapper, rest, /*#__PURE__*/_react.default.createElement(_SecondaryNav.NavContainer, null, links && /*#__PURE__*/_react.default.createElement(_SecondaryNav.LinkList, null, links.map(function (item, key) {
    return /*#__PURE__*/_react.default.createElement(_SecondaryNav.NavLink, {
      key: key.toString(),
      to: item.url,
      onClick: item.onClick,
      enhanced: true // TODO - the isActive is leaking all the way to the link and breaks the html standard
      // we are passing as string for now to mitigate multiple warning that hinder development
      ,
      active: (active === item.url).toString()
    }, item.label);
  })), secondaryNavCtas && secondaryNavCtas.map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_SecondaryNav.NavBtn, Object.assign({
      key: action.label,
      variant: globalNav.secondaryNavCtaVariant
    }, action), action.label);
  })));
};

SecondaryNav.propTypes = {
  links: _propTypes.default.arrayOf(Object),
  secondaryNavCtas: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  active: _propTypes.default.string
};
SecondaryNav.defaultProps = {
  links: [],
  secondaryNavCtas: [],
  active: ''
};
var _default = SecondaryNav;
exports.default = _default;